module.exports = __webpack_public_path__ + "img/23.44fb308f.png";